import { DsChipColorVariant } from '@levelaccess/design-system';

import { accountStatus } from '../../../shared/constants/user';

export class UserStatusUtility {
  public static getStatusTranslationKey(status?: string, mustChangePassword?: boolean): string {
    if (status === accountStatus.active && mustChangePassword) {
      return 'status_password_invalidated';
    }
    return status ? `status_${status}` : '';
  }

  public static getStatusChipVariant(status?: string, mustChangePassword?: boolean): DsChipColorVariant {
    if (status === accountStatus.active && mustChangePassword) {
      return DsChipColorVariant.Warning;
    }
    switch (status) {
      case accountStatus.active:
        return DsChipColorVariant.Success;
      case accountStatus.inactive:
        return DsChipColorVariant.Danger;
      case accountStatus.closed:
        return DsChipColorVariant.LightGray;
      default:
        return DsChipColorVariant.Gray;
    }
  }
}
